import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Pagination } from '@mui/material';
const useStyles = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
  },
}));

const TablePaginationActions = (props) => {
  const classes = useStyles();
  const { count, rowsPerPage, onPageChange, page } = props;
  const numOfPages = Math.ceil(count / rowsPerPage);

  const handleChange = (event, value) => {
    const changedPage = value - 1;
    onPageChange(event, changedPage);
  };

  return (
    <div className={classes.root}>
      {numOfPages > 1 && (
        <Pagination
          page={page + 1}
          count={numOfPages}
          variant='outlined'
          shape='rounded'
          defaultPage={1}
          siblingCount={1}
          boundaryCount={0}
          onChange={handleChange}
        />
      )}
    </div>
  );
};

export default TablePaginationActions;
